<template>
    <footer class="rodape">
        <div class="imgs-footer">
            <img src="../../assets/logo-repense-branco.png" alt="" class="img-footer repense">
            <img src="../../assets/logo-huddle-branco.png" alt="" class="img-footer">
        </div>
    </footer>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .rodape{
        height: 50px;
        width: 100%;
        background-color: #02f0e4;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: flex-end;

        .imgs-footer{

            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 50%;

            .img-footer{
                height: 20px;
            }

            .repense{
                height: 25px;
            }
        }
    }

    @media only screen and (min-width: 600px){
        .rodape{

            .imgs-footer{

                width: 200px;
            }
        }
    }
</style>
